import React, { Component } from "react";
import {API, Storage, Analytics} from "aws-amplify";
import {Helmet} from "react-helmet";
import {
  Alert,
  Button,
  Col,
  Form, FormControl,
  FormGroup,
  Grid, InputGroup,
  Modal,
  OverlayTrigger,
  Popover,
  ProgressBar,
  Row
} from 'react-bootstrap';
import SocialShare from "../../components/Marketing/SocialShare";
import Editor, {createEditorStateWithText} from 'draft-js-plugins-editor';
import {EditorState, convertFromRaw} from 'draft-js';
import createLinkifyPlugin from 'draft-js-linkify-plugin';
import 'draft-js-linkify-plugin/lib/plugin.css';
import {Link, Redirect} from "react-router-dom";
import ReactGA from 'react-ga';
import validator from "validator";
import moment from "moment";
import CountdownTimer from "../../components/Profile/CountdownTimer";
import GiveCredits from "../../components/Profile/GiveCredits";
import MergeProfile from "../../components/Profile/MergeProfile";
import GoogleMap from "../../components/GoogleMap";
import ReCAPTCHA from "react-google-recaptcha";
const linkifyPlugin = createLinkifyPlugin({ target: '_blank' });
const plugins = [linkifyPlugin];

export default class extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      certificationModal: false,
      resumeModal: false,
      bsClass: 'modal-header modal-header-info',
      modalTitle: '',
      modalMessage: '',
      pageNotFound: false,
      user: {},
      certifiedSince: null,
      profileResume: '',
      coverPhoto: 'directory.jpg',
      profilePic: 'profile.jpg',
      isLoadingContactMeButton: false,
      email: '',
      subject: '',
      message: '',
      CAPTCHA: '',
      certificationUpdated: Date.now(),
      remainingCertifications: [],
      pageLoading: true,
      editorState: createEditorStateWithText('')
    };
    this.onChange = (editorState) => this.setState({editorState});
    this._reCaptchaRef = React.createRef();
  }

  certificationUpdated = updated => {this.setState({ certificationUpdated: updated });};

  async componentDidMount() {
    await this.loadProfile();
    ReactGA.initialize('UA-134679120-1');
    ReactGA.pageview(window.location.pathname);
    Analytics.record('profileVisit', { userId: this.props.match.params.userid });
    window.fbq('track', 'ViewContent');
    // scroll to the top of the page when the component mounts
    // window.scrollTo({top:0, behavior: 'smooth'});
    // smooth scroll to the profile page after the component mounts
    const elementID = document.getElementById('profilePic');
    if (elementID) {
      elementID.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    if(prevState.certificationUpdated!==this.state.certificationUpdated){
      await this.loadProfile();
    }
  }

  async loadProfile()  {
    try {
      const user = await API.get("api", `/profile/${this.props.match.params.userid}`);
      if (!user.hasOwnProperty("userId")) {this.setState({pageNotFound: true});}
      this.setState({user});
      const profilePicList = await Storage.list('', {
        level: 'protected',
        identityId: this.state.user.cognitoIdentityId
      });
      profilePicList.map(async (pic) => {
        if (pic.key === 'profile.jpg') {
          const profilePic = await Storage.get('profile.jpg', {
            level: 'protected',
            identityId: this.state.user.cognitoIdentityId
          });
          this.setState({profilePic});
        }
        if (pic.key === 'cover.jpg') {
          const coverPhoto = await Storage.get('cover.jpg', {
            level: 'protected',
            identityId: this.state.user.cognitoIdentityId
          });
          this.setState({coverPhoto});
        }
        if (pic.key === 'resume.pdf') {
          const profileResume = await Storage.get('resume.pdf', {
            level: 'protected',
            identityId: this.state.user.cognitoIdentityId
          });
          this.setState({profileResume});
        }
      });
      if(user.about) {this.setState({editorState: EditorState.createWithContent(convertFromRaw(JSON.parse(user.about)))});}

      if (this.state.user.userName) {
        document.title = process.env.REACT_APP_COMPANY_NAME+" | "+this.state.user.userName;
      } else {
        document.title = process.env.REACT_APP_COMPANY_NAME+" | Page Not Found";
      }

      // change meta 3,4,5,6 for og: title, image, description, url
      document.getElementsByTagName("META")[3].content=`${this.state.user.userName}'s ${process.env.REACT_APP_COMPANY_NAME} Profile`;
      document.getElementsByTagName("META")[4].content=`${this.state.coverPhoto}`;
      document.getElementsByTagName("META")[5].content=`View ${this.state.user.userName}'s profile on ${process.env.REACT_APP_COMPANY_NAME}.`;
      document.getElementsByTagName("META")[6].content=`//${process.env.REACT_APP_DOMAIN_NAME}/${this.state.user.displayedURL ? this.state.user.displayedURL : this.state.user.userId}`;

      // parse the certifications and set state for valid, invalid, and remaining certifications
      let remainingCertifications = [
        'AWS Certified Cloud Practitioner',
        'AWS Certified AI Practitioner',
        'AWS Certified Solutions Architect - Associate',
        'AWS Certified Developer - Associate',
        'AWS Certified SysOps Administrator - Associate',
        'AWS Certified Data Engineer - Associate',
        'AWS Certified Machine Learning Engineer - Associate',
        'AWS Certified Solutions Architect - Professional',
        'AWS Certified DevOps Engineer - Professional',
        'AWS Certified Advanced Networking - Specialty',
        'AWS Certified Security - Specialty',
        'AWS Certified Machine Learning - Specialty'
      ];
      let certifiedSince;
      if (user.hasOwnProperty("certifications")) {
        const now = Math.floor(Date.now() / 1000);
        // loop through all the certifications and push them either into the validCertifications or invalidCertifications
        // and remove the valid certifications from the remainingCertifications array
        user.certifications.map((certification) => {
          if (certification.expires >= now + 5) {
            // remove the valid certification from the remainingCertifications array
            remainingCertifications = remainingCertifications.filter(e => e !== certification.title);
          }
          // find out when this person first became certified
          if (isNaN(certifiedSince)) {
            certifiedSince = certification.issued*1000;
          } else {
            if (certification.issued*1000 < certifiedSince) certifiedSince = certification.issued*1000;
          }
          return true;
        });
      }

      this.setState({remainingCertifications, certifiedSince, pageLoading: false});
    } catch (e) {
      this.setState({pageNotFound: true});
    }
  }

  validateContactForm() {
    if (this.props.isAuthenticated) {
      return (
        validator.isLength(this.state.subject, {min:3, max:undefined}) &&
        validator.isLength(this.state.message, {min:6, max:undefined})
      );
    } else {
      return (
        validator.isEmail(this.state.email) &&
        validator.isLength(this.state.subject, {min:3, max:undefined}) &&
        validator.isLength(this.state.message, {min:6, max:undefined}) &&
        this.state.CAPTCHA
      );
    }
  }

  emailValidationState() {
    if (validator.isEmail(this.state.email)) return 'success';
    else if (this.state.email.length > 6 && this.state.email.includes("@")) return 'warning';
    else if (this.state.email.length > 6 && !validator.isEmail(this.state.email)) return 'error';
    return null;
  }

  subjectValidationState() {
    if (this.state.subject.length >= 3) return 'success';
    return null;
  }

  messageValidationState() {
    if (this.state.message.length >= 6) return 'success';
    return null;
  }

  updateEmailForm = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  };

  handleCAPTCHA = value => {
    if (value === null) {
      this.setState({CAPTCHA: ''});
    } else {
      this.setState({CAPTCHA: value});
    }
  };

  emailUser = async event => {
    event.preventDefault();
    this.setState({ isLoadingContactMeButton: true });
    try {
      await API.post("api", "/email", {
        body: {
          email: this.state.email,
          subject: this.state.subject,
          message: this.state.message,
          form: 'profileEmail',
          to: this.state.user.userId,
          CAPTCHA: this.state.CAPTCHA
        }
      });
      this.setState({
        email: '',
        subject: '',
        message: '',
        CAPTCHA: '',
        showModal: true,
        bsClass: 'modal-header modal-header-success',
        modalTitle: "Email Sent",
        modalMessage: `Your email was sent to ${this.state.user.userName}. The ball is in their court now.`
      });

      // TODO fix error handling on the server to callback response message if CAPTCHA is invalid

      /*window.grecaptcha.reset();
      this.setState({
        CAPTCHA: '',
        modalTitle: "Error!",
        bsClass: 'modal-header modal-header-danger',
        modalMessage: "reCAPTCHA did not validate on the server! Are you a bot?",
        showModal: true
      });*/
    } catch (e) {
      this.setState({
        showModal: true,
        modalTitle: "Error!",
        bsClass: 'modal-header modal-header-danger',
        modalMessage: `There was a problem trying to send the email to ${this.state.user.userName}!`
      });
    } finally {
      this.setState({
        isLoadingContactMeButton: false
      });
    }
  };

  renderCertificationsAlert() {
    if (!this.state.isLoading) {
      if (!this.state.user.hasOwnProperty("certifications") || this.state.remainingCertifications.length === 12) {
        return (
          <Alert style={{marginBottom: 15}} bsStyle="danger">
            <div style={{fontSize: 18, textAlign: 'center'}}><b>No AWS Certifications Uploaded!</b></div>
          </Alert>
        );
      }
    }
  }

  renderCertificationsProgressBar() {
    if (!this.state.isLoading) {
      if (this.state.remainingCertifications.length > 0 && this.state.remainingCertifications.length !== 12) {
        return (
          <div key="progress">
            <ProgressBar style={{marginBottom:2}} active bsStyle="success" now={100 - Math.ceil(this.state.remainingCertifications.length * 8.333333333)}/>
            <div style={{marginBottom:10, textAlign: 'center', fontSize:12, color:'#999999', fontStyle:'italic'}}>
              {this.state.user.displayedURL === "JasperThayer" ? "Jasper" : "This user"} has {12-this.state.remainingCertifications.length} out of 12 certifications
            </div>
          </div>
        );
      } else if (this.state.remainingCertifications.length === 0) {
        return (
          <div>
            <ProgressBar style={{marginBottom:2}} active bsStyle="success" now={100} />
            <div style={{marginBottom:10, textAlign: 'center', fontSize:12, color:'#999999', fontStyle:'italic'}}>
              {this.state.user.displayedURL === "JasperThayer" ? "Jasper" : "This user"} has attained all 12 AWS certifications
            </div>
          </div>
        );
      }
    }
  }

  renderCertifications() {
    // loop through the certifications
    if (!this.state.isLoading && this.state.user.hasOwnProperty("certifications")) {
      const now = Math.floor(Date.now() / 1000);
      if (this.state.user.certifications.length > 0) {
        return this.state.user.certifications.map((certification) => {
          let validStyle = {paddingLeft: 0, paddingRight: 0, marginBottom: -1};
          return (
            <div key={certification.fileName}>
              {certification.expires >= now && <Col sm={12} style={validStyle}>
                <div className='certification valid-certification'>
                  {certification.expires >= now + 5 && <OverlayTrigger
                    placement="right"
                    delayShow={300}
                    delayHide={150}
                    overlay={<Popover id={certification.validationNumber}>
                      View the official validation for this <b>{certification.title}</b> certification.
                    </Popover>}>
                    <a
                      href={'https://aw.certmetrics.com/amazon/public/verification.aspx?code='+certification.validationNumber}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      <i style={{color: '#5cb85c', marginRight: 5}} className='fa fa-check fa-fw' aria-hidden='true'/>
                    </a>
                  </OverlayTrigger>}

                  {certification.expires >= now + 5 && <OverlayTrigger
                    placement="right"
                    delayShow={300}
                    delayHide={150}
                    overlay={
                      <Popover id={certification.fileName}>
                        View this <b>{certification.title}</b> certification.
                      </Popover>}>
                    <a
                      href={`https://${process.env.REACT_APP_DOMAIN_NAME}`}
                      onClick={(e) => this.viewCertification(e, certification.fileName)}
                    >
                      {certification.title}
                    </a>
                  </OverlayTrigger>}

                  {certification.expires >= now + 5 && certification.issued && <div>
                    <b>Issued:</b> {moment(certification.issued*1000).format("MMMM D, YYYY")}
                  </div>}

                  {/*show the expiration date if I've updated it in DynamoDB*/}
                  {parseInt(certification.expires) !== 1777777777 && parseInt(certification.expires) > now + 3888000 && <div>
                    <b>Expires:</b> {moment(certification.expires*1000).format("MMMM D, YYYY")}
                  </div>}

                  {/*this certification expires in about a month*/}
                  {parseInt(certification.expires) > now + 2246400 && parseInt(certification.expires) <= now + 3888000 && <div>
                    <b>Expires:</b> {moment(certification.expires*1000).fromNow()}
                  </div>}

                  {/*this certification expires today*/}
                  {parseInt(certification.expires) > now + 3600 && parseInt(certification.expires) <= now + 2246400 && <div>
                    <b>Expires:</b> <span style={{color:'#d9534f'}}>{moment(certification.expires*1000).fromNow()}</span>
                  </div>}

                  {/*this certification expires in less than an hour*/}
                  {parseInt(certification.expires) <= now + 3600 && <CountdownTimer
                    expiration={certification.expires * 1000}
                    certificationUpdated={this.certificationUpdated}
                  />}
                </div>
              </Col>}
            </div>
          );
        });
      }
    }
  }

  renderRemainingCertifications() {
    // loop through the remainingCertifications array
    if (!this.state.isLoading) {
      return this.state.remainingCertifications.map((greyCertification, i) => {
        let remainingStyle = {paddingLeft: 0, paddingRight: 0, marginBottom: -1};
        if (this.state.remainingCertifications.length === (i + 1)) {remainingStyle.marginBottom = 0;}
        // TODO update this.state.remainingCertifications.length !== 14 when the new certification is GA
        if (this.state.remainingCertifications.length !== 12 && i === 0) {remainingStyle.marginTop = 15;}
        return (
          <Col sm={12} style={remainingStyle} key={greyCertification}>
            <div className='certification grey-certification'>
              {greyCertification}
            </div>
          </Col>
        );
      });
    }
  }

  viewCertification = (e, fileName) => {
    e.preventDefault();
    this.setState({
      certificationModal: true,
      modalMessage: fileName
    });
  };

  viewResume = () => this.setState({resumeModal: true});

  modalClose = () => {this.setState({showModal: false, certificationModal: false, resumeModal: false});};

  render() {
    const { pageNotFound } = this.state;
    if (pageNotFound) {return <Redirect to={{pathname: '/404'}} />;}
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    let lat;
    let lng;

    if (this.state.user.userLocation) {
      if (this.state.user.userLocation.lat && this.state.user.userLocation.lng) {
        lat = Number(this.state.user.userLocation.lat);
        lng = Number(this.state.user.userLocation.lng);
      }
    }

    return (
      <div>

        <Helmet>
          <meta property="og:title" content={`View ${this.state.user.userName}'s ${process.env.REACT_APP_COMPANY_NAME} Profile`}/>
          <meta property="og:image" content={`${this.state.coverPhoto}`}/>
          {this.state.user.hasOwnProperty('certifications') && <meta property="og:description" content={`${this.state.user.userName} is an AWS Certified professional with ${this.state.user.certifications.length} AWS Certifications.`}/>}
          <meta property="article:author" content={`${this.state.user.userName}`}/>
          <meta property="og:url" content={`//${process.env.REACT_APP_DOMAIN_NAME}/${this.state.user.userId}`}/>
        </Helmet>

        {!this.state.pageLoading && <img className="banner" alt={`${process.env.REACT_APP_DOMAIN_NAME} Profile Cover`} src={this.state.coverPhoto}/>}
        <Grid className="page">
          {!this.state.pageLoading && <Row className="show-grid">
            <Col xs={12}>
              <img id="profilePic" className="profilePic" alt={`${process.env.REACT_APP_DOMAIN_NAME} Profile Pic`} src={this.state.profilePic}/>
              {this.state.user.displayedURL && <div>
                <h1 className="profileName" style={{marginTop:15, marginBottom:-8}}>{this.state.user.userName} {this.state.remainingCertifications.length === 0 && <i style={{color:'#FFD700', textShadow: '0 0 1px #000'}} className="fa fa-star fa-fw" aria-hidden="true"/>}{this.state.profileResume && <OverlayTrigger
                  placement="right"
                  delayShow={300}
                  delayHide={150}
                  overlay={<Popover id="popoverResume">
                    View Resume
                  </Popover>}>
                  <i style={{cursor:'pointer'}} onClick={this.viewResume} className="fa fa-file-text-o fa-fw" aria-hidden="true"/>
                </OverlayTrigger>}</h1>
                <span style={{fontSize:9}}><i>@{this.state.user.displayedURL}</i></span>
              </div>}
              {!this.state.user.displayedURL && <h1 className="profileName">{this.state.user.userName} {this.state.remainingCertifications.length === 0 && <i style={{color:'#FFD700', textShadow: '0 0 1px #000'}} className="fa fa-star fa-fw" aria-hidden="true"/>}{this.state.profileResume && <OverlayTrigger
                placement="right"
                delayShow={300}
                delayHide={150}
                overlay={<Popover id="popoverResume">
                  View Resume
                </Popover>}>
                <i style={{cursor:'pointer'}} onClick={this.viewResume} className="fa fa-file-text-o fa-fw" aria-hidden="true"/>
              </OverlayTrigger>}</h1>}
            </Col>

            <Col xs={12}>

              {this.props.isAdmin && <div style={{marginTop:5, marginBottom:-5, fontSize:9}}>
                <Link to={`/admin/user/${this.state.user.userId}`}>
                  <i className="fa fa-gears fa-fw" aria-hidden="true"/> <i>Admin</i>
                </Link>
              </div>}

              {this.state.user.userLocation && <div style={{marginTop:5, marginBottom:0, fontSize:9}}>
                <i className="fa fa-map-marker fa-fw" aria-hidden="true"/>
                {this.state.user.userLocation.city && this.state.user.userLocation.userRegion && <span>{this.state.user.userLocation.city}, {this.state.user.userLocation.userRegion}</span>}
                {this.state.user.userLocation.city && !this.state.user.userLocation.userRegion && <span>{this.state.user.userLocation.city}</span>}
                {!this.state.user.userLocation.city && this.state.user.userLocation.userRegion && <span>{this.state.user.userLocation.userRegion}</span>}
                {this.state.user.userLocation.country && <span> {this.state.user.userLocation.country}</span>}
              </div>}

              {this.state.user.userLocation && <div style={{marginTop:0, marginBottom:5, fontSize:9}}>
                {!isNaN(this.state.certifiedSince) && <div><b><i className="fa fa-calendar fa-fw" aria-hidden="true"/> AWS Certified Since:</b> <span>
                  {months[new Date(Number(this.state.certifiedSince)).getMonth()]}{' '}
                  {new Date(Number(this.state.certifiedSince)).getDate()},{' '}
                  {new Date(Number(this.state.certifiedSince)).getFullYear()}</span>
                </div>}
                <GiveCredits giveToId={this.state.user.userId} name={this.state.user.userName} recalculatePurse={this.props.recalculatePurse}/>
                <MergeProfile childId={this.state.user.userId} childName={this.state.user.userName} childProvider={this.state.user.provider}/>
              </div>}

              {!this.state.user.userLocation && <div style={{marginTop:5, marginBottom:5, fontSize:9}}>
                {!isNaN(this.state.certifiedSince) && <div>
                  <b><i className="fa fa-calendar fa-fw" aria-hidden="true"/> AWS Certified Since:</b> <span>
                  {months[new Date(Number(this.state.certifiedSince)).getMonth()]}{' '}
                  {new Date(Number(this.state.certifiedSince)).getDate()},{' '}
                  {new Date(Number(this.state.certifiedSince)).getFullYear()}</span>
                </div>}
                <GiveCredits giveToId={this.state.user.userId} name={this.state.user.userName} recalculatePurse={this.props.recalculatePurse}/>
                <MergeProfile childId={this.state.user.userId} childName={this.state.user.userName} childProvider={this.state.user.provider}/>
              </div>}

              <SocialShare
                style={{marginBottom:10}}
                size="xs"
                url={`https://${process.env.REACT_APP_DOMAIN_NAME}/${this.state.user.displayedURL ? this.state.user.displayedURL : this.state.user.userId}`}
                title={`View ${this.state.user.userName}'s profile on the ${process.env.REACT_APP_COMPANY_NAME}.`}
              />

              {this.state.user.socialMedia && <div style={{marginBottom:10}}>
                {/* LinkedIn */}
                {this.state.user.socialMedia.linkedin && <OverlayTrigger
                  placement="top"
                  delayShow={300}
                  delayHide={150}
                  overlay={<Popover id="popoverLinkedIn">
                    Connect with <b>{this.state.user.userName}</b> on LinkedIn.
                  </Popover>}>
                  <a
                    style={{paddingRight:5}}
                    href={`https://linkedin.com/in/${this.state.user.socialMedia.linkedin}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Button bsStyle="default" bsSize="xsmall">
                      <i className="fa fa-linkedin fa-fw" aria-hidden="true"/>
                    </Button>
                  </a>
                </OverlayTrigger>}

                {/* GitHub */}
                {this.state.user.socialMedia.github && <OverlayTrigger
                  placement="top"
                  delayShow={300}
                  delayHide={150}
                  overlay={<Popover id="popoverGitHub">
                    Fork <b>{this.state.user.userName}</b> on GitHub.
                  </Popover>}>
                  <a
                    style={{paddingRight:5}}
                    href={`https://github.com/${this.state.user.socialMedia.github}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Button bsStyle="default" bsSize="xsmall">
                      <i className="fa fa-github fa-fw" aria-hidden="true"/>
                    </Button>
                  </a>
                </OverlayTrigger>}

                {/* Facebook */}
                {this.state.user.socialMedia.facebook && <OverlayTrigger
                  placement="top"
                  delayShow={300}
                  delayHide={150}
                  overlay={<Popover id="popoverFacebook">
                  Connect with <b>{this.state.user.userName}</b> on Facebook.
                </Popover>}>
                  <a
                    style={{paddingRight:5}}
                    href={`https://facebook.com/${this.state.user.socialMedia.facebook}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Button bsStyle="default" bsSize="xsmall">
                      <i className="fa fa-facebook fa-fw" aria-hidden="true"/>
                    </Button>
                  </a>
                </OverlayTrigger>}

                {/* Twitter */}
                {this.state.user.socialMedia.twitter && <OverlayTrigger
                  placement="top"
                  delayShow={300}
                  delayHide={150}
                  overlay={<Popover id="popoverTwitter">
                    Follow <b>@{this.state.user.socialMedia.twitter}</b> on Twitter
                  </Popover>}>
                  <a
                    style={{paddingRight:5}}
                    href={`https://twitter.com/${this.state.user.socialMedia.twitter}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Button bsStyle="default" bsSize="xsmall">
                      <i className="fa fa-twitter fa-fw" aria-hidden="true"/>
                    </Button>
                  </a>
                </OverlayTrigger>}

                {/* Website */}
                {this.state.user.socialMedia.website && <OverlayTrigger
                  placement="top"
                  delayShow={300}
                  delayHide={150}
                  overlay={<Popover id="popoverURL">
                    Visit <b>{this.state.user.socialMedia.website}</b>
                  </Popover>}>
                  <a
                    href={this.state.user.socialMedia.website}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Button bsStyle="default" bsSize="xsmall">
                      <i className="fa fa-desktop fa-fw" aria-hidden="true"/>
                    </Button>
                  </a>
                </OverlayTrigger>}
              </div>}
            </Col>

            <Col xs={12} sm={6} md={5} lg={4}>
              {this.renderCertificationsAlert()}
              {this.renderCertificationsProgressBar()}
              {this.renderCertifications()}
              {this.renderRemainingCertifications()}
            </Col>

            <Col sm={6} md={7} lg={8}>

              {lat && lng &&
              <GoogleMap
                id={this.state.user.userId}
                options={{
                  center:{lat, lng},
                  zoom:11,
                  minZoom: 4,
                  maxZoom: 18,
                  streetViewControl:false,
                  mapTypeControl:false,
                  styles:[{"featureType": "poi", "stylers": [{"visibility": "off"}]}, {"featureType": "transit", "stylers": [{"visibility": "off"}]}]
                }}
                onMapLoad={map => {
                  let marker, i;
                  if (this.state.user.certifications.length >= 12) {
                    // Create a STAR marker of the certified user if they have all 12 certifications
                    marker = new window.google.maps.Marker({
                      position: {lat, lng},
                      map: map,
                      icon: 'map-star.png',
                      animation: window.google.maps.Animation.DROP,
                      title: this.state.user.userName
                    });
                  } else {
                    // Create a marker of the certified user
                    marker = new window.google.maps.Marker({
                      position:{lat, lng},
                      map:map,
                      icon:'map-marker.png',
                      animation: window.google.maps.Animation.DROP,
                      title:this.state.user.userName
                    });
                  }
                  const infowindow = new window.google.maps.InfoWindow();
                  // if the user has any certifications, then show an info window with all their certifications in it.
                  if (this.state.user.hasOwnProperty("certifications")) {
                    // Loop through the array of certifications for the current user
                    // and create divs of the certifications that we can use to show in the info window for the selected user
                    let usersCertifications = '';
                    for (let certification = 0; certification < this.state.user.certifications.length; certification++) {
                      usersCertifications += '<div style="font-weight:bold;">' +
                        '<a style="text-decoration: none;" title="View the official validation for this ' + this.state.user.certifications[certification].title + ' certification."' +
                        ' href="https://aw.certmetrics.com/amazon/public/verification.aspx?code=' + this.state.user.certifications[certification].validationNumber + '" target="_blank">' +
                        '<i style="color:#5cb85c; margin-right:5" class="fa fa-check fa-fw"></i> ' +
                        '</a>' +
                        '<a href="https://s3.amazonaws.com/' + process.env.REACT_APP_S3_BUCKET.toLowerCase() + '/certifications/' + this.state.user.certifications[certification].fileName + '" target="_blank">'
                        + this.state.user.certifications[certification].title +
                        '</a>' +
                        '</div>';
                    }

                    // Create an info window when someone clicks on the certified user's marker
                    marker.addListener('click', ((marker, i) => {
                      return () => {
                        if (this.state.user.certifications.length >= 12) {
                          infowindow.setContent(
                            '<h1 style="margin-top:0">' + this.state.user.userName + ' <i style="color:#FFD700; text-shadow:0 0 1px #000" class="fa fa-star fa-fw" aria-hidden="true"></i></h1>' + usersCertifications
                          );
                        } else {
                          infowindow.setContent(
                            '<h1 style="margin-top:0">' + this.state.user.userName + '</h1>' + usersCertifications
                          );
                        }
                        infowindow.open(map, marker);
                      }
                    })(marker, i));
                  } else {
                    // Create an info window when someone clicks on the certified user's marker
                    marker.addListener('click', ((marker, i) => {
                      return () => {
                        infowindow.setContent(
                          '<h1 style="margin-top:0">Warning!</h1>' +
                          '<div style="font-weight:bold;">' +
                          '<i style="color:#d9534f; margin-right:5" class="fa fa-warning fa-fw"></i> ' +
                          this.state.user.userName+' needs to upload their AWS certifications to see them displayed here in the map marker info window.' +
                          '</div>' +
                          '<button style="margin-top:15px;" onclick="window.location.href = \'profile\';" class="btn btn-xs btn-success btn-block">' +
                          '<i class="fa fa-plus fa-fw"></i> ' +
                          'Add AWS Certification' +
                          '</button>'
                        );
                        infowindow.open(map, marker);
                      }
                    })(marker, i));
                  }
                }}
              />}

              {this.state.user.about && lat && lng && <div>
                <h2 style={{marginTop:10}}>About {this.state.user.userName}:</h2>
                <Editor
                  editorState={this.state.editorState}
                  onChange={this.onChange}
                  plugins={plugins}
                  readOnly
                />
              </div>}

              {this.state.user.about && !lat && !lng && <div>
                <h2 style={{marginTop:-6}}>About {this.state.user.userName}:</h2>
                <Editor
                  editorState={this.state.editorState}
                  onChange={this.onChange}
                  plugins={plugins}
                  readOnly
                />
              </div>}

              {this.state.user.contactForm && <div>
                {(this.state.user.about || (lat && lng)) && <h2 style={{marginTop:10}}>Contact {this.state.user.userName}:</h2>}
                {!this.state.user.about && !lat && !lng && <h2 style={{marginTop:-6}}>Contact {this.state.user.userName}:</h2>}
                <Row>
                  <Form onSubmit={this.emailUser}>

                    {/* Email */}
                    {!this.props.isAuthenticated && <Col xs={12}><FormGroup bsSize="small" style={{marginBottom:5}} validationState={this.emailValidationState()}>
                      <InputGroup>
                        <InputGroup.Addon><i className="fa fa-envelope-o fa-fw" aria-hidden="true"/></InputGroup.Addon>
                        <FormControl
                          autoFocus
                          type="email"
                          id="email"
                          autoComplete="off"
                          placeholder="Your Email"
                          value={this.state.email}
                          onChange={this.updateEmailForm}
                        />
                      </InputGroup>
                    </FormGroup></Col>}

                    {/* Email Subject */}
                    <Col xs={12}><FormGroup bsSize="small" style={{marginBottom:5}} validationState={this.subjectValidationState()}>
                      <InputGroup>
                        <InputGroup.Addon><i className="fa fa-vcard-o fa-fw" aria-hidden="true"/></InputGroup.Addon>
                        <FormControl
                          type="text"
                          id="subject"
                          autoComplete="off"
                          placeholder="Subject"
                          value={this.state.subject}
                          onChange={this.updateEmailForm}
                        />
                      </InputGroup>
                    </FormGroup></Col>

                    {/* Message */}
                    <Col xs={12}>
                      <FormGroup bsSize="small" style={{marginBottom:5}} validationState={this.messageValidationState()}>
                        <InputGroup>
                          <InputGroup.Addon><i className="fa fa-pencil-square-o fa-fw" aria-hidden="true"/></InputGroup.Addon>
                          <FormControl
                            style={{height:100}}
                            id="message"
                            componentClass="textarea"
                            placeholder="Message"
                            value={this.state.message}
                            onChange={this.updateEmailForm}
                          />
                        </InputGroup>
                      </FormGroup>
                    </Col>

                    {!this.props.isAuthenticated && <Col xs={12}>
                      <ReCAPTCHA
                        ref={this._reCaptchaRef}
                        sitekey="6Lc3uLUUAAAAABOIMkh6BA4yXwk9KfdbGBEXdoXT"
                        onChange={this.handleCAPTCHA}
                      />
                    </Col>}

                    {/* Send Message Button */}
                    <Col xs={12}>
                      <Button
                        bsStyle={!this.validateContactForm() ? "default" : "success"}
                        bsSize="small"
                        className="LoaderButton"
                        disabled={!this.validateContactForm() || this.state.isLoadingContactMeButton}
                        style={{marginTop:3}}
                        type="submit"
                        block
                      >
                        {this.state.isLoadingContactMeButton && <i className="fa fa-refresh fa-fw spinning" aria-hidden="true"/>}
                        {!this.state.isLoadingContactMeButton && <i className="fa fa-paper-plane-o fa-fw" aria-hidden="true"/>}
                        {!this.state.isLoadingContactMeButton ? " Send Message" : " Sending Message…"}
                      </Button>
                    </Col>
                  </Form>
                </Row>
              </div>}
            </Col>
          </Row>}

          {this.state.pageLoading && <div className='LoaderButton' style={{fontSize:150, textAlign:'center', marginBottom:-20}}>
            <i className="fa fa-refresh fa-fw spinning" aria-hidden="true"/>
          </div>}

          <Modal show={this.state.certificationModal} onHide={this.modalClose} dialogClassName="certification-modal">
            <Modal.Body style={{padding:0}}>
              <img
                width='100%'
                height='100%'
                alt={process.env.REACT_APP_COMPANY_NAME}
                src={`https://s3.amazonaws.com/${process.env.REACT_APP_S3_BUCKET.toLowerCase()}/certifications/${this.state.modalMessage}`}
              />
            </Modal.Body>
          </Modal>

          <Modal show={this.state.resumeModal} onHide={this.modalClose} dialogClassName="resume-modal">
            <Modal.Body style={{padding:0}}>
              <iframe title="resume" src={this.state.profileResume} style={{width:'100%',height:'75vmin'}} frameBorder="0">
              </iframe>
            </Modal.Body>
          </Modal>

          <Modal show={this.state.showModal} onHide={this.modalClose}>
            <Modal.Header bsClass={this.state.bsClass} closeButton>
              <i className="fa fa-warning fa-fw" aria-hidden="true"/> {this.state.modalTitle}
            </Modal.Header>
            <Modal.Body>
              {this.state.modalMessage}
            </Modal.Body>
          </Modal>
        </Grid>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/Profile/ProfileView.js